import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/user-groups/$groupId/members')({
  component: () => <Outlet />,
});
